import { createStore } from 'vuex'

const URL = 'https://server-web.konaweselatankab.go.id/';
const URL_SIMPEG = 'https://server-egov.konaweselatankab.go.id/';
var UNIT = '2BjJ3ahYMzDYc9QCZ';

export default createStore({
  state: {
    UNIT_KERJA : UNIT,
    url: {
      URL_APP_SIMPEG: URL_SIMPEG, 
      URL_APP: URL,
      URL_SLIDER: URL + 'api/v1/publish_dlh_slider/',
      URL_BERITA: URL + 'api/v1/web_publish_berita/',
      URL_SAMBUTAN: URL + 'api/v1/publish_dlh_sambutan/',
      URL_LINK_TERKAIT: URL + 'api/v1/web_publish_link_terkait/',
      URL_FOTO: URL + 'api/v1/publish_dlh_foto/',
      URL_DATA_PEGAWAI: URL + 'api/v1/publish_dlh_data_pegawai/',
      URL_PROGRAM_KEGIATAN: URL + 'api/v1/publish_dlh_program_kegiatan/',
      URL_TENTANG_KAMI: URL + 'api/v1/publish_dlh_tentang_kami/',
      URL_TUGAS_POKOK: URL + 'api/v1/publish_dlh_tugas_pokok/',
      URL_VISI_MISI: URL + 'api/v1/publish_dlh_visi_misi/',
      URL_STRUKTUR_ORGANISASI: URL + 'api/v1/publish_dlh_struktur_organisasi/',
      URL_BID_TATA_LINGKUNGAN: URL + 'api/v1/publish_dlh_bidang_tata_lingkungan/',
      URL_BID_PENGELOLAAN_SAMPAH: URL + 'api/v1/publish_dlh_bidang_pengelolaan_sampah_limbah/',
      URL_BID_PENGENDALIAN_PENCEMARAN: URL + 'api/v1/publish_dlh_bidang_pengendalian_pencemaran_kerusakan/',
      URL_BID_PENATAAN_PENINGKATAN: URL + 'api/v1/publish_dlh_bidang_penataan_dan_peningkatan/',
      URL_SEKRETARIAT: URL + 'api/v1/publish_dlh_sekretariat/',
      URL_FORMULIR: URL + 'api/v1/publish_dlh_download_formulir/',
      URL_SOP: URL + 'api/v1/publish_dlh_sop/',
      URL_VIDEO: URL + 'api/v1/publish_dlh_video/',
      URL_LAYANAN: URL + 'api/v1/publish_dlh_layanan/',
    },
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
